import { render, staticRenderFns } from "./otpconfirmpage.vue?vue&type=template&id=5422ee3e&scoped=true"
import script from "./otpconfirmpage.vue?vue&type=script&lang=js"
export * from "./otpconfirmpage.vue?vue&type=script&lang=js"
import style0 from "./otpconfirmpage.vue?vue&type=style&index=0&id=5422ee3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5422ee3e",
  null
  
)

export default component.exports